module.exports = __webpack_public_path__ + "img/Academic_Researc.b928dd61.jpg";